import type React from 'react';

interface UsageCardProps {
    title: string;
    text: string | React.ReactNode;
    Icon?: React.ElementType;
    className?: string;
}

export default function UsageCard({ title, text, Icon, className }: UsageCardProps) {
    const svgBorderStyle = {
        backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3cdefs%3e%3clinearGradient id='grad' x1='0%25' y1='0%25' x2='100%25' y2='0%25'%3e%3cstop offset='30.09%25' stop-color='%23B30169'/%3e%3cstop offset='90.2%25' stop-color='%23EA05FF'/%3e%3c/linearGradient%3e%3c/defs%3e%3crect x='1.5' y='1.5' width='calc(100%25 - 3px)' height='calc(100%25 - 3px)' stroke='url(%23grad)' stroke-width='3' fill='none' rx='14.5'/%3e%3c/svg%3e")`,
    };

    return (
        <div className={`${className ? `${className} ` : ''}relative bg-[#0E0E0E] rounded-[16px] p-[25px]`}>
            <div className="absolute inset-0 rounded-[16px] pointer-events-none" style={svgBorderStyle} />

            <div className="flex items-center justify-center mb-3 relative z-10">
                {Icon ? (
                    <div className="bg-gradient-to-r from-[#B30169] to-[#EA05FF] p-2 rounded-full mr-3">
                        <Icon />
                    </div>
                ) : undefined}
                <h3 className="uppercase font-bold text-lg text-center">{title}</h3>
            </div>
            <p className="text-sm leading-[1.5] relative z-10">{text}</p>
        </div>
    );
}
